import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useQuestionFields, QuestionFields } from "./QuestionFields.js";
export function QuestionsForm({ requests, onRespond }) {
    const { fields, setSelected, setFreeText, allAnswered, buildAnswers } = useQuestionFields(requests);
    const [submitted, setSubmitted] = useState(false);
    const handleSubmit = () => {
        if (submitted || !allAnswered)
            return;
        setSubmitted(true);
        onRespond(buildAnswers());
    };
    return (_jsxs("div", { className: "questions-form", children: [_jsx("div", { className: "questions-header", children: "\uD83D\uDCAC A few questions to continue" }), _jsx(QuestionFields, { requests: requests, fields: fields, setSelected: setSelected, setFreeText: setFreeText, disabled: submitted, onEnter: handleSubmit }), _jsx("div", { className: "questions-actions", children: _jsx("button", { className: "btn-submit-answers", onClick: handleSubmit, disabled: submitted || !allAnswered, type: "button", children: submitted ? "Submitted" : "Submit answers" }) })] }));
}
//# sourceMappingURL=QuestionsForm.js.map